import type {PhosphorIconAsset} from "@khanacademy/wonder-blocks-icon";

import batteryEmptyIcon from "@phosphor-icons/core/regular/battery-empty.svg";
import batteryFullIcon from "@phosphor-icons/core/regular/battery-full.svg";
import batteryHighIcon from "@phosphor-icons/core/regular/battery-high.svg";
import batteryLowIcon from "@phosphor-icons/core/regular/battery-low.svg";
import batteryMediumIcon from "@phosphor-icons/core/regular/battery-medium.svg";
import batteryWarningIcon from "@phosphor-icons/core/regular/battery-warning.svg";

export const getIcon = (percent: number): PhosphorIconAsset => {
    if (percent > 0.75) {
        return batteryFullIcon as PhosphorIconAsset;
    }
    if (percent > 0.5) {
        return batteryHighIcon as PhosphorIconAsset;
    }
    if (percent > 0.25) {
        return batteryMediumIcon as PhosphorIconAsset;
    }
    if (percent > 0.1) {
        return batteryLowIcon as PhosphorIconAsset;
    }
    if (percent > 0.0) {
        return batteryWarningIcon as PhosphorIconAsset;
    }
    return batteryEmptyIcon as PhosphorIconAsset;
};
